import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import PrimitiveValueObject from "_framework/entities/values/primitive-value-object";
import TitleSchema, { TitleJSON } from "_shared/titles/_schema/title-schema";

export default class Title extends PrimitiveValueObject<Title, string, TitleJSON> {
  public static create(value: string): Title {
    const validated = TitleSchema.validate(value);
    return new Title(validated);
  }

  public static fromJSON(data: unknown): Title | null | undefined {
    if (isNullOrUndefined(data)) return data;
    const parsed = TitleSchema.deserialize(data);
    return new Title(parsed);
  }

  public constructor(public readonly value: string) {
    super(value);
    if (!value) {
      throw new InvalidTitleError("Title must have a value.");
    }
  }

  public toJSON(): TitleJSON {
    return TitleSchema.serialize(this.value);
  }

  public valueOf(): string {
    return this.value;
  }

  public isEqualTo(other: Title | null | undefined): boolean {
    if (!other) return false;
    return this.value === other.value;
  }

  public toString(): string {
    return `Title { value: ${this.value} }`;
  }
}

export class InvalidTitleError extends Error {}
